var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoPlain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 574.72 180"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 180A90 90 0 100 90a90 90 0 0090 90z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2 88.8v48h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2 136.8v-48h48z",
    fill: "#00796b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2 88.8v-48h48z",
    fill: "#b2dfdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2 40.8v48h-48z",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.46 20.45h24.41l-19.36 139h-23.83zm58.06 50.74c9-8.13 18.1-12.37 28.62-12.37 17 0 29.2 12 29.2 29a127 127 0 01-1.67 16.62l-7.39 55.05h-23.87l7.07-53.73a93 93 0 001.07-12c0-8.49-5.35-12.74-12.75-12.74-5.72 0-12.38 3.14-16.81 8.31-7 8.13-8.68 20-10.69 35.46l-4.61 34.73h-24L272 61.4h24zm109.09-50.74c-20 0-23.59 16.19-26.71 41h-10.53l-2.77 20.64h10.29l-10.54 77.4h24l10.68-77.4h15l2.77-20.69h-14.97c1.81-13.42 1.54-20 7.83-20.29h10.68l2.78-20.7m25.62 41.03c-20 0-23 13.88-26.13 38.67l-2.95 20.69-5.25 38.69h24l5.45-38.69 2.51-18.33.25-2.36c1.82-13.43.94-17.76 7.23-18h10.69l2.76-20.69m73.44 84.93c-9 8.49-17 13.11-29.91 13.11-25.63 0-42.49-21.8-42.49-47.66 0-30.11 24.2-55.55 52.65-55.55a33.54 33.54 0 0129.19 16.25l1.49-11h24.05l-12.82 98h-23.74zm6.66-42.12c0-14.79-9.42-25.86-24.57-25.86-16.81 0-30.67 13.66-30.67 34 0 15.51 9.79 25.64 24.2 25.64 19.77.06 31-17.12 31-33.74z",
    fill: "#212121"
  })))));
}

export default SvgLogoPlain;